import BaseService from './base.service';

export default class UnassignedDevicesService {
    static ENDPOINT = '/orgs';

    static async getUnassignedDevices(orgId) {
        const endpoint = `${this.ENDPOINT}/${orgId}/unassigned-devices`;
        return BaseService.get(endpoint);
    }

    static async uploadUnassignedDevices(orgId, unassignedDevices) {
        const endpoint = `${this.ENDPOINT}/${orgId}/unassigned-devices/upload`;
        return BaseService.post(endpoint, unassignedDevices);
    }

    static async updateUnassignedDevice(orgId, id, data) {
        const endpoint = `${this.ENDPOINT}/${orgId}/unassigned-devices/${id}`;
        return BaseService.patch(endpoint, data);
    }

    static async deleteUnassignedDevice(orgId, id) {
        const endpoint = `${this.ENDPOINT}/${orgId}/unassigned-devices/${id}`;
        return BaseService.delete(endpoint);
    }
}
